import { ApiBase } from '../apiBase';
import { ApiHexaBase } from './ApiHexaBase';
import { Customer } from './models/CustomerModels';

export class ApiCustomer extends ApiHexaBase {
  public static override get baseUrl(): string {
    return `${ApiHexaBase.baseUrl}/customers`;
  }

  public static async index(params: {
    page?: number;
    size?: number;
    search?: string;
    active?: boolean;
    expiring?: boolean;
    low_credits?: boolean;
    sort_field?: string;
    sort_direction?: 'asc' | 'desc';
  }) {
    const response = await ApiBase.get(this.baseUrl, params);
    return response.data.data as {
      total: number;
      customers: Customer[];
    };
  }

  public static async show(id: number | string) {
    const response = await ApiBase.get(`${this.baseUrl}/${id}`);

    return response.data.data as Customer;
  }

  public static async create(data: Partial<Customer>) {
    return await ApiCustomer.update('new', data);
  }

  public static async update(id: number | string, data: Partial<Customer>) {
    const response = await ApiBase.post(`${this.baseUrl}/${id}`, data);
    return response.data.data as Customer;
  }

  public static async destroy(id: number | string) {
    const response = await ApiBase.delete(`${this.baseUrl}/${id}`);

    return response.data.data as Customer;
  }
}
